import { render } from "./OrderDetail.vue?vue&type=template&id=d942723c&scoped=true"
import script from "./OrderDetail.vue?vue&type=script&lang=js"
export * from "./OrderDetail.vue?vue&type=script&lang=js"

import "./OrderDetail.vue?vue&type=style&index=0&id=d942723c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d942723c"

export default script